import { useState } from "react";
import styles from "./NewContact.module.scss";
import email from "./../icons/email.png";
import home from "./../icons/home.png";
import call from "./../icons/call.png";
import arrow from "./../icons/arrow-menu.svg";
import PocketBase from 'pocketbase';

const NewContact = () => {
  const [ form, setForm ] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
  });
  const pb = new PocketBase('https://atom.pockethost.io/');

  const sendEmail = async (e) => {
    e.preventDefault();
    // if (!privacyPolicyCheckbox) {
    //   setErrorMessage('Zaakceptuj politykę prywatności');
    //   return;
    // }
    // if (!consentCheckbox) {
    //   setErrorMessage('Wyraź zgodę na przetwarzanie danych osobowych');
    //   return;
    // }
    // if (form.name === '') {
    //   setErrorMessage('Uzupełnij imię i nazwisko dziecka');
    //   return;
    // }
    // if (form.phone === '') {
    //   setErrorMessage('Uzupełnij numer telefonu');
    //   return;
    // }

    try {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('phone', form.phone);
      formData.append('email', form.email);
      formData.append('message', form.message);
      // // formData.append('privacyPolicyConsent', privacyPolicyCheckbox);
      // // formData.append('dataProcessingConsent', consentCheckbox);
      // // formData.append('privacyPolicyConsentDate', dayjs(new Date()));
      // // formData.append('dataProcessingConsentDate', dayjs(new Date()));
      console.log('3:', form.name, form.phone, form.email, form.message);
      await pb.collection('germania').create(formData).then((res) => {
        // setIsSuccess(true);
        // setErrorMessage('');
        setForm({
          name: '',
          phone: '',
          email: '',
          message: '',
        });
      });
    }
    catch (e) {
      console.log(e.data.data)
      // if (Object.keys(e.data.data).includes('name')) {
      //   setErrorMessage('Uzupełnij imię i nazwisko');
      // }
      // else if (Object.keys(e.data.data).includes('phone')) {
      //   setErrorMessage('Uzupełnij numer telefonu');
      // }
      // else if (Object.keys(e.data.data).includes('birth')) {
      //   setErrorMessage('Uzupełnij datę urodzenia dziecka');
      // }
      // else {
      //   setErrorMessage('Wystąpił problem z wysłaniem danych');
      // }
    }
  }

  return (
    <div className={styles.container}>
      <div className={`${styles.content} content`}>
        {/* <div className={styles.contenttext}>

        </div> */}
        <div className={styles.left}>
          <h1 className={styles.text}>Skontaktuj sie ze mna</h1>
          <div className={styles.contactbox}>
            <img src={call} />
            <div className={styles.contactboxtext}>
              <p>Pod numerem telefonu:</p>
              <p>+48 500 039 101</p>
              <p>+48 61 8 670 508</p>
            </div>
          </div>
          <div className={styles.contactbox}>
            <img src={email} />
            <div className={styles.contactboxtext}>
              <p>Poprzez wiadomość e-mail:</p>
              <p>dolata@germania.pl</p>
            </div>
          </div>
          <div className={styles.contactbox}>
            <img src={home} />
            <div className={styles.contactboxtext}>
              <p>Osobiście w biurze:</p>
              <p>ul. Newtona 12A/34</p>
              <p>60-161 Poznań</p>
            </div>
          </div>
        </div>
        <div className={styles.right}>
          <form onSubmit={(e) => sendEmail(e)}>
            <p>Lub poprzez formularz kontaktowy:</p>
            <textarea
              value={form.message}
              onChange={e => setForm({...form, message: e.target.value})}
              type="text"
              name="Wiadomość"
              placeholder="Tutaj wpisz swoją wiadomość"
              required
            ></textarea>
            <p>Podaj swoje dane kontaktowe, aby umożliwić mi odpowiedź:</p>
            <div className={styles.formbottom}>
              <input
                value={form.name}
                onChange={e => setForm({...form, name: e.target.value})}
                type="text"
                name="Imię i nazwisko"
                placeholder="Imię i nazwisko"
                required
              />
              <input
                value={form.email}
                onChange={e => setForm({...form, email: e.target.value})}
                type="email"
                name="Email"
                placeholder="E-mail"
                required
              />
              <input
                value={form.phone}
                onChange={e => setForm({...form, phone: e.target.value})}
                type="text"
                name="Numer telefonu"
                placeholder="Numer telefonu"
              />
            </div>
            <div className={`${styles.button} basicbutton`} type="submit">
              <button type="submit">wyslij</button>
              {/* <a href="https://g.page/r/CWiB1NK3dQ3IEBE/review" target="_blank">
            Napisz opinię
          </a> */}
              <img src={arrow} />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default NewContact;
